import { render, staticRenderFns } from "./GameEndCountdown.vue?vue&type=template&id=75366cd8&"
import script from "./GameEndCountdown.vue?vue&type=script&lang=js&"
export * from "./GameEndCountdown.vue?vue&type=script&lang=js&"
import style0 from "./GameEndCountdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75366cd8')) {
      api.createRecord('75366cd8', component.options)
    } else {
      api.reload('75366cd8', component.options)
    }
    module.hot.accept("./GameEndCountdown.vue?vue&type=template&id=75366cd8&", function () {
      api.rerender('75366cd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GameEndCountdown.vue"
export default component.exports